<script>

import config from '../../common/genericPanelConf';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable
    },
    data(){
        return{
            configuration: null
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        
    },
    computed: {
        conf(){
            return config;
        }
    }
}
</script>



<template>
    <div class="" style="height: 80vh;">
        <GenericDataTable :configuration="configuration" :category="category" :name="name" />
    </div>
</template>